export const translations = {
  sv: {
    sharelabel: 'Dela med',
  },
  en: {
    sharelabel: 'Share to',
  },
  da: {
    sharelabel: 'Del med',
  },
  no: {
    sharelabel: 'Dele med',
  },
  fi: {
    sharelabel: 'Jakaa',
  },
  zh: {
    sharelabel: 'Share to',
  },
  it: {
    sharelabel: 'Share to',
  },
  nl: {
    sharelabel: 'Share to',
  },
};
